module.exports = __webpack_public_path__ + "static/media/eprize2.07bd4bbc.png";